export default "__VITE_ASSET__108f42aa__"